<template>
  <div class="import__page">
    <div>
      <p>
        {{
          $route.name == "todoist"
            ? $t("import.messages.todoist_importing")
            : $t("import.messages.microsoft_importing")
        }}
      </p>
      <el-progress
        :text-inside="true"
        :stroke-width="26"
        :percentage="progress"
        v-if="$route.name == 'todoist'"
      ></el-progress>
      <span
        v-else
        v-show="progress == 0"
        class="image-pre-loader image-pre-loader-red"
      ></span>
      <span>{{ message }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { EventEmitter } from "../main";

export default {
  name: "Import",
  data() {
    return {
      progress: 0,
      message: this.$t("import.messages.do_not_close"),
    };
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.code) {
        this.$socket.connect();
        this.$socket.emit("IN_ImportData", {
          type: this.$route.name,
          token: this.$route.query.code,
          option: { update: "update" },
        });
      }
    }

    EventEmitter.$on("SOCKET_OUT_ImportData", (data) => {
      if (data) {
        this.progress = 100;
        setTimeout(() => {
          this.message = this.$t("import.messages.done");
        }, 1000);
        setTimeout(() => {
          window.close();
        }, 3000);
      } else {
        if (this.$route.name == "todoist") {
          this.message = this.$t("import.messages.todoist_limit");
        } else {
          this.message = this.$t("import.messages.microsoft_limit");
        }
      }
    });

    EventEmitter.$on("SOCKET_OUT_ImportDataProgress", (data) => {
      this.progress = data;
    });
  },
  methods: {
    ...mapActions([
      // "socket_import"
    ]),
  },
};
</script>
